import React, { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import { Link } from "react-router-dom";
import "./Home.css";

class Navbar extends Component {
    handleLogout = () => {
        localStorage.removeItem("token");
        window.location.href = "admin/login";
    };
    render() {
        return (
            <div className="container-fluid m-0 p-0  home-div">
                <div className="container-fluid Nav-bar d-flex align-items-center justify-content-between px-3">

                    {/* LEFT: Logo */}
                    <Link to="/" className="navbar-brand d-flex align-items-center flavours-nest-logo">
                        <img src="/asset/logo.png" alt="FlavoursNest Graphic" className="logo-img" />

                        {/* <div className="d-flex flex-column">
              <h1 className="logo-title m-0">
                <span className="fw-bold text-dark-brown">Flavours</span>
                <span className="fw-semibold text-golden-tan">Nest</span>
               

              </h1>

              <p className="logo-subtitle m-0 text-uppercase fw-semibold">
                Your Cozy Home For Recipes
              </p>
            </div> */}
                    </Link>


                    {/* RIGHT: Dashboard + Logout */}
                    <div className="d-flex align-items-center gap-2">
                        <button
                            className="btn btn-success"
                            onClick={() => this.props.router.navigate("/")}
                        >
                            Category
                        </button>

                        <button
                            className="btn btn-warning"
                            onClick={() => this.props.router.navigate("/admin/dashboard")}
                        >
                            📊 Dashboard
                        </button>

                        <button className="logout-btn" onClick={this.handleLogout}>
                            Logout
                        </button>

                    </div>

                </div>


            </div>
        );
    }
}

export default withRouter(Navbar);